import { NgModule } from '@angular/core';
import { TagsComponent } from './tags.component';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from '../../../shared';

const MODULES = [CommonModule, SkeletonModule];

@NgModule({
  declarations: [TagsComponent],
  exports: [TagsComponent],
  imports: [MODULES],
})
export class TagsModule {}
